// extracted by mini-css-extract-plugin
export var dividerLine = "_67-0";
export var errorBackground = "_67-1";